"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactOutsideClickHandler = _interopRequireDefault(require("react-outside-click-handler"));

var _data = _interopRequireDefault(require("./data"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

require("./styles.css");

var styles = {
  "container": "styles-module__container___1oeWd",
  "container-error": "styles-module__container-error___30Vv0",
  "input": "styles-module__input___2kmrh",
  "select": "styles-module__select___3pPfK",
  "select__title": "styles-module__select__title___3tAxy",
  "control": "styles-module__control___gOLYV",
  "dropdown_menu": "styles-module__dropdown_menu___8S-s_",
  "dropdown_menu__element": "styles-module__dropdown_menu__element___2TmwC",
  "countyName": "styles-module__countyName___8ZhVQ",
  "countyLabel": "styles-module__countyLabel___UyGrU",
  "dropdownElementImage": "styles-module__dropdownElementImage___DNR1C"
};

var Caret = function Caret() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3 6L7.5 10.5L12 6",
    stroke: "#858585",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var debounce = function debounce(func, wait) {
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      func.apply(context, args);
    }, wait);
  };
};

var ReactMask = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      _ref$classnames = _ref.classnames,
      classnames = _ref$classnames === void 0 ? {
    container: '',
    select: '',
    selectTitle: '',
    input: '',
    dropdown: '',
    dropdownMenuElement: '',
    dropdownElementImg: '',
    dropdownElementCountryName: '',
    dropdownElementLabel: '',
    selectImg: '',
    containerError: ''
  } : _ref$classnames,
      _ref$CaretComponent = _ref.CaretComponent,
      CaretComponent = _ref$CaretComponent === void 0 ? Caret : _ref$CaretComponent,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$dropdownData = _ref.dropdownData,
      dropdownData = _ref$dropdownData === void 0 ? _data.default : _ref$dropdownData,
      errors = _ref.errors,
      _ref$nativeChange = _ref.nativeChange,
      nativeChange = _ref$nativeChange === void 0 ? false : _ref$nativeChange,
      _ref$dataTestIds = _ref.dataTestIds,
      dataTestIds = _ref$dataTestIds === void 0 ? {
    container: '',
    select: '',
    selectTitle: '',
    input: '',
    dropdown: '',
    dropdownMenuElement: function dropdownMenuElement() {
      return '';
    },
    dropdownElementImg: function dropdownElementImg() {
      return '';
    },
    dropdownElementCountryName: function dropdownElementCountryName() {
      return '';
    },
    dropdownElementLabel: function dropdownElementLabel() {
      return '';
    },
    selectImg: '',
    containerError: '',
    mainInput: ''
  } : _ref$dataTestIds;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(dropdownData[0]),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedData = _useState4[0],
      setSelectedData = _useState4[1];

  var _useState5 = (0, _react.useState)(value.slice(2)),
      _useState6 = _slicedToArray(_useState5, 2),
      inputValue = _useState6[0],
      setInputValue = _useState6[1];

  var handleChangeInput = function handleChangeInput(e) {
    if (e.target.validity.valid) {
      var _value = e.target.value;
      setInputValue(_value);
      onChange(selectedData.code + _value);
    }
  };

  var handleSelectDropdown = function handleSelectDropdown(index) {
    return function () {
      setSelectedData(dropdownData[index]);
      onChange(dropdownData[index].code + inputValue);
      setIsOpen(false);
    };
  };

  var handleToggleDropdown = debounce(function () {
    return setIsOpen(!isOpen);
  }, 300);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "\n          ".concat(styles['container'], " ").concat(classnames.container, "\n          ").concat(errors !== null && errors !== void 0 && errors.length ? styles['container-error'] || classnames.containerError : null),
    "data-testid": dataTestIds.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": dataTestIds.select,
    className: "".concat(styles['select'], " ").concat(classnames.select),
    onClick: handleToggleDropdown
  }, /*#__PURE__*/_react.default.createElement(CaretComponent, null), /*#__PURE__*/_react.default.createElement("img", {
    alt: "flag-".concat(selectedData.countryName),
    src: selectedData.icon,
    className: "".concat(classnames.selectImg, " ").concat(styles['dropdownElementImage']),
    "data-testid": dataTestIds.selectImg
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(styles['select__title'], " ").concat(classnames.selectTitle),
    "data-testid": dataTestIds.selectTitle
  }, selectedData.code)), /*#__PURE__*/_react.default.createElement("input", {
    ref: ref,
    value: inputValue,
    type: "text",
    onChange: handleChangeInput,
    pattern: "[0-9]+",
    className: "".concat(styles['input'], " ").concat(classnames.input),
    "data-testid": dataTestIds.input
  })), isOpen && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(styles['dropdown_menu'], " ").concat(classnames.dropdown),
    "data-testid": dataTestIds.dropdown
  }, /*#__PURE__*/_react.default.createElement(_reactOutsideClickHandler.default, {
    onOutsideClick: handleToggleDropdown
  }, dropdownData.map(function (_ref2, index) {
    var _dataTestIds$dropdown, _dataTestIds$dropdown2, _dataTestIds$dropdown3, _dataTestIds$dropdown4;

    var code = _ref2.code,
        countryName = _ref2.countryName,
        icon = _ref2.icon;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(styles['dropdown_menu__element'], " ").concat(classnames.dropdownMenuElement),
      onClick: handleSelectDropdown(index),
      "data-testid": (_dataTestIds$dropdown = dataTestIds.dropdownMenuElement) === null || _dataTestIds$dropdown === void 0 ? void 0 : _dataTestIds$dropdown.call(dataTestIds, index)
    }, /*#__PURE__*/_react.default.createElement("img", {
      alt: "flag-".concat(countryName),
      src: icon,
      className: "".concat(classnames.dropdownElementImg, " ").concat(styles['dropdownElementImage']),
      "data-testid": (_dataTestIds$dropdown2 = dataTestIds.dropdownElementImg) === null || _dataTestIds$dropdown2 === void 0 ? void 0 : _dataTestIds$dropdown2.call(dataTestIds, index)
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(styles['countyName'], " ").concat(classnames.dropdownElementCountryName),
      "data-testid": (_dataTestIds$dropdown3 = dataTestIds.dropdownElementCountryName) === null || _dataTestIds$dropdown3 === void 0 ? void 0 : _dataTestIds$dropdown3.call(dataTestIds, index)
    }, countryName), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(styles['countyLabel'], " ").concat(classnames.dropdownElementLabel),
      "data-testid": (_dataTestIds$dropdown4 = dataTestIds.dropdownElementLabel) === null || _dataTestIds$dropdown4 === void 0 ? void 0 : _dataTestIds$dropdown4.call(dataTestIds, index)
    }, code));
  }))), /*#__PURE__*/_react.default.createElement("input", {
    style: {
      display: 'none'
    },
    name: name,
    value: selectedData.code + inputValue,
    "data-testid": dataTestIds.mainInput,
    readOnly: true
  }));
});
var _default = ReactMask;
exports.default = _default;